/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery'
import 'slick-carousel'
import each from 'lodash/each'

function setupCarousel(el) {
  const $carousel = $(el)
  const options = {
    infinite: true,
    lazyLoad: 'progressive',
    adaptiveHeight: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    rows: 0, // required to stop IE11 from adding a gap due to slick's row setup logic
    prevArrow: $('#slider-prev').html(),
    nextArrow: $('#slider-next').html(),
  }

  options.autoplay = !!$carousel.data('autoplay')
  options.autoplaySpeed = parseInt($carousel.data('autoplay-speed'), 10) * 1000
  options.pauseOnHover = !!$carousel.data('pause-on-hover')
  options.speed = $carousel.data('animation') === 'none' ? 0 : parseInt($carousel.data('animation-speed'), 10)
  options.fade = $carousel.data('animation') === 'fade'
  options.swipe = !!$carousel.data('allow-swiping')
  options.arrows = !!$carousel.data('arrows')
  options.dots = !!$carousel.data('dots')

  $carousel.slick(options)
}

/**
 * Set up carousels in the container.
 *
 * @param {HTMLElement} container
 */
function setupCarousels(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('.carousel')
  if (existingEls.length) {
    each(existingEls, (el) => {
      if (el.closest('.reveal')) {
        return
      }
      setupCarousel(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll('.carousel')
        if (!els.length) {
          return
        }

        each(els, (el) => {
          if (el.matches('.slick-initialized')) {
            return
          }
          setupCarousel(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

/**
 * Destroy carousels in the container.
 *
 * @param {HTMLElement} container
 */
function destroyCarousels(container) {
  const $container = $(container)
  if (!$container.length) {
    return
  }

  $container.find('.carousel').each((idx, carouselEl) => {
    $(carouselEl).slick('unslick')
  })
}

export { setupCarousels, destroyCarousels }

